module.exports = __webpack_public_path__ + "img/general6.1d4e123a.jpg";